// extracted by mini-css-extract-plugin
module.exports = {"activeVolumeInfo":"_15MljB","preview":"_23Ob3a","priceTitle":"_2Gzcza","textContainer":"_16ZsA2","desc":"_2wp4VV"};